export type Device = "phone" | "tablet" | "desktop";

/** `< 768` phone, `< 1024` tablet, else desktop. */
export function deviceFromWidth(w: number): Device {
  if (w < 768) return "phone";
  if (w < 1024) return "tablet";
  return "desktop";
}
